import { IImage, Image } from 'app/constants/schemas/Image';
import { IUserProfile, UserProfile } from 'app/constants/schemas/UserProfile';
import { Ability, AbilityMarshaller } from 'app/constants/enums/Ability';
import vmClient from 'app/services/vmClient';
import { Entity, EntityStringId, IEntityType, IEntity } from 'app/types/entity';
import {
  LanguageProficiencyMarshaller,
  LanguageProficiencies,
} from 'app/constants/schemas/LanguageProficiencies';
import {
  TeachingSkillsMarshaller,
  TeachingSkills,
} from 'app/constants/schemas/TeachingSkills';
import { Country, CountryMarshaller } from 'app/constants/enums/Country';

export interface ITeacher extends IEntity {
  attributes: {
    enabled: boolean;
    gender: string;
    id: EntityStringId;
    name: string;
    nationality: Country;
    skypeId: string;
    languageProficiencies: LanguageProficiencies;
    teachingSkills: TeachingSkills;
    externalProfileAffiliation: string | null;
    abilities: Ability[];
  };
  associations: {
    profileImage: IImage | null;
    user: IUserProfile;
  };
}

export const teacherAttributes = {
  enabled: 'boolean',
  gender: 'string',
  name: 'string',
  externalProfileAffiliation: 'string',
  nationality: {
    type: Country,
    marshaller: CountryMarshaller,
    notNull: true,
  },
  skypeId: 'string',
  languageProficiencies: {
    type: LanguageProficiencies,
    marshaller: LanguageProficiencyMarshaller,
  },
  teachingSkills: {
    type: TeachingSkills,
    marshaller: TeachingSkillsMarshaller,
  },
  abilities: {
    collection: true,
    type:       Ability,
    marshaller: AbilityMarshaller,
  },
};

export const teacherAssociations = {
  profileImage: Image,
  user: {
    shared: true,
    type: UserProfile,
  },
};

export type Teacher = Entity<ITeacher>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Teacher: IEntityType<ITeacher> = vmClient.defineClass({
  typeName: 'Teacher',
  version: 5,
  lockable: true,
  persisted: true,

  attributes: teacherAttributes,
  associations: teacherAssociations,
});
